import type { FaireProductEntity } from "../../entity_types/product";

export const p_w28js88559: FaireProductEntity = {
  token: "p_w28js88559",
  type: "product",
  name: "Stainless Steel Tea Strainer | Faire Market Bestseller",
  brandToken: "b_7pzhk0cjaf",
  brandName: "Bamboo Switch",
  imageUrl:
    "https://cdn.faire.com/fastly/a030eec277f45c2354b1f949564d19d2a57d74ececd102be33546c801eb8efef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2d9dc531557456546506c81ca90d82ad1fcb34c862ddd58cb0dd197d98338ddf.webp",
    "https://cdn.faire.com/fastly/f5302ae99a2b481e23a22688225d66bac668e0e454ca4a93167ee5d6973b8a8a.png",
    "https://cdn.faire.com/fastly/c787b6acd8bbeb9b2869bc4975813dfc4633fbceb44bd3651c935ed0bb5300e3.jpeg",
    "https://cdn.faire.com/fastly/f8d1984c5a91b7c38ab4786ff38df71463f2fc93d51aef02fb85b0bbe4ec32ee.png",
    "https://cdn.faire.com/fastly/20b57fd6b3f852258093a8b1e660a69f3e6b5b6edf5a04e069702ca71b332259.jpeg",
    "https://cdn.faire.com/fastly/aa264a50b1219d4d742e9fe5d9a2b5fed6e1ec2056325ffc51314add214021d5.png",
    "https://cdn.faire.com/fastly/b93226f23b1452d0d1f17c3d995ec0f6d8ae5046f5c93c5885b396df45669176.png",
    "https://cdn.faire.com/fastly/8ec694bab9da7cf41f2b689fed2572de3f49af1e06cb7c492ab19a175f9e8476.png",
    "https://cdn.faire.com/fastly/e0e4e0218196fee64a003719d70520656e4a1a5fd456ee9a7c0902be588a6116.png",
    "https://cdn.faire.com/fastly/d7fda20caaf7b9d844b7160340aeb1fd9b64fa6d71bc15da99356231201f0257.png",
    "https://cdn.faire.com/fastly/e3df39028bf289ba1f636c88019d079c8fea2c493a88675376daab50465bc7df.jpeg",
  ],
  priceDollars: 3.55,
  description:
    "Our Stainless Steel Tea Strainer Filters are the perfect fit for any loose tea leaf size.\nBrew the perfect cup of loose-leaf tea with this durable stainless steel strainer for smooth, debris free tea and a convenient handle for easy use. Let's skip all the single-use plastic-filled tea bags and switch to the basic tea experience!\n\n𝐇𝐨𝐰 𝐭𝐨 𝐔𝐬𝐞:\nSimply open the ball and pour in a scoop of tea leaves, close it and let it simmer in hot water until the desired taste is reached.\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\nRinse thoroughly after each use and hand wash or place in the dishwasher.\n\n𝐖𝐡𝐚𝐭'𝐬 𝐈𝐧𝐜𝐥𝐮𝐝𝐞𝐝:\nOne Stainless Steel Tea Strainer\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥:\nStainless Steel\n\n𝐃𝐢𝐦𝐞𝐧𝐬𝐢𝐨𝐧𝐬:\nLength: 7 inches\nDiameter: 2 inches\n\n𝐏𝐚𝐜𝐤𝐚𝐠𝐢𝐧𝐠:\nThis product is package-free, meaning it is sold without individual wrapping or external packaging.\n\nBranded: No\n\nAble to White Label: Yes",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:27:48.489Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
